import { DataLayer } from '@grandvisionhq/analytics';

const ContactLensesConfigEvent = 'ContactLensesConfigEvent';
const pushSelectBoxQuantity = (totalPrice, frequency, quantity)=>{
    DataLayer.pushEvent({
        event: ContactLensesConfigEvent,
        eventAction: 'select box quantity',
        eventLabel: undefined,
        RxContactLenses: {
            productConfig: {
                price: `${totalPrice.centAmount / 100}`,
                box: {
                    frequency,
                    quantity
                }
            }
        }
    });
};

export { pushSelectBoxQuantity };
//# sourceMappingURL=contact-lens-data-layer.js.map
